// extracted by mini-css-extract-plugin
export default {"layout":"BatchJobs_layout__9r3AF","headerCard":"BatchJobs_headerCard__SMpbv","card":"BatchJobs_card__txHNe"};